const instantDateFields = new Set([
  "createdDate",
  "createdTime",
  "dateGenerated",
  "lastLoginDate",
  "lastUpdatedTime",
  "modDate",
  "modifiedDate",
  "processedShowResultsEnteredAfter",
]);

const isRecord = (value: unknown): value is Record<string, unknown> =>
  Object.prototype.toString.call(value) === "[object Object]";

const instantPattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,3})?Z$/;
const plainDatePattern = /^\d{4}-\d{2}-\d{2}$/;
const plainDateTimePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,9})?$/;
const plainTimePattern = /^\d{2}:\d{2}:\d{2}(?:\.\d{1,9})?$/;
const showSessionFields = new Set(["showTime", "time"]);
const plainDateArrayFields = new Set(["conflictingWhelpingDates"]);

const hydrateString = (key: string, value: string): unknown => {
  if (key.endsWith("At") || instantDateFields.has(key)) {
    if (!instantPattern.test(value)) throw new RangeError(`Invalid instant value for ${key}`);
    return Temporal.Instant.from(value);
  }

  if (/datetime$/i.test(key)) {
    if (!plainDateTimePattern.test(value)) throw new RangeError(`Invalid date-time value for ${key}`);
    return Temporal.PlainDateTime.from(value);
  }

  if (/(?:date|birthdate)$/i.test(key) || plainDateArrayFields.has(key)) {
    if (!plainDatePattern.test(value)) throw new RangeError(`Invalid date value for ${key}`);
    return Temporal.PlainDate.from(value);
  }

  if (/time$/i.test(key) && !showSessionFields.has(key)) {
    if (!plainTimePattern.test(value)) throw new RangeError(`Invalid time value for ${key}`);
    return Temporal.PlainTime.from(value);
  }

  return value;
};

export const hydrateTemporal = (value: unknown, key = ""): any => {
  if (typeof value === "string") return hydrateString(key, value);
  if (Array.isArray(value)) return value.map(item => hydrateTemporal(item, key));
  if (!isRecord(value)) return value;

  return Object.fromEntries(
    Object.entries(value).map(([childKey, childValue]) => [
      childKey,
      hydrateTemporal(childValue, childKey),
    ])
  );
};
